import BaseModal from 'components/modal/BaseModal';
import useGlobalModal from 'hooks/useGlobalModal';

const GlobalModal = () => {
  const {
    isModalOpen,
    leftBtnName,
    rightBtnName,
    TextComponent,
    handleClickLeftBtn,
    handleClickRightBtn
  } = useGlobalModal();

  return (
    <BaseModal
      isModalOpen={isModalOpen}
      leftBtnName={leftBtnName}
      rightBtnName={rightBtnName}
      onClickLeftBtn={handleClickLeftBtn}
      onClickRightBtn={handleClickRightBtn}
      onCloseModal={handleClickLeftBtn}
    >
      {TextComponent}
    </BaseModal>
  );
};

export default GlobalModal;
